/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import Glide from '@glidejs/glide';

import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query'; 
import { type App } from '~/app';

import JsController from '../../js-controller';

import { CLASS_NAME } from './constants';

export default (app: App) => {

    const controller = new JsController(app, 'Halcyon Home Header');
    controller.addMountFunction(() => {
        mountHalcyonHomeHeader(controller);
    })

    return controller.init();
}

export function mountHalcyonHomeHeader( controller: JsController ) {
    const elements = document.querySelectorAll<HTMLElement>(`.${CLASS_NAME}`);
    let index = 0;
    for (const element of elements) {
        handleScrollArrowClick(controller, element);
        mountCarousel(controller, element, index);
        index++;
    }
}

// Handle scroll arrow click
const handleScrollArrowClick = (controller: JsController, element: HTMLElement) => {

    const slideArrows = element.querySelectorAll('.scroll-to-bottom-of-hero');

    if (slideArrows.length > 0) {
        for (const slideArrow of slideArrows) {
            controller.addListener(slideArrow, "click", () => {
                const navigation = document.querySelector<HTMLElement>('.navigation');
                const navigationHeight = navigation ? navigation.clientHeight : 0;
                const scrollToPos = element.getBoundingClientRect().bottom + window.scrollY - navigationHeight;
                window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
            });
        }
    }
}

// Handle scroll arrow click
const mountCarousel = (controller: JsController, element: HTMLElement, carouselIndex: number) => {
    const imageCarousel = element.querySelector('.glide__track');
    if (imageCarousel) {
        const indexClass = `${CLASS_NAME}-${carouselIndex}`;
        element.classList.add(indexClass);
        const glide: Glide = new Glide(`.${indexClass}`, {
            type: 'slider',
            perView: 1,
            startAt: 0,
            gap: 0,
            autoplay: 5000,
            rewind: true,
        })
           
        glide.on(['mount.after', 'run'], function() {
            const bannerDescriptions = document.querySelectorAll<HTMLElement>('.banner-description')
            for (const description of bannerDescriptions) {

                if( description.classList.contains(`description-${glide.index}`)){
                    description.classList.add('opacity-100')

                    if (isMobile()) {
                        description.classList.remove('hidden')
                        description.classList.add('relative')
                    }
                }else{
                    if(isMobile()){
                        description.classList.add('hidden')
                        description.classList.remove('relative') 
                    }     

                    description.classList.add('opacity-0')
                    description.classList.remove('opacity-100')
                }
            }

        })

        glide.mount()  
        controller.addCarouselInstance(glide);
    }
}